import { Card } from '@features/ui';
import { FC, ReactNode } from 'react';
import { cn } from '@lib/utils.ts';
import { formatDateTimeMST } from '@lib/utils';
import { AdminOverviewStatus } from '@src/types/status';

interface LabelProps {
  children?: ReactNode;
  className?: string;
  bold?: boolean;
}
const Title: FC<LabelProps> = ({ children, className }) => {
  return <p className={cn('text-sm font-bold', className)}>{children}</p>;
};
const Desc: FC<LabelProps> = ({ children, className, bold }) => {
  return (
    <p className={cn('text-xs', bold ? 'font-bold' : '', className)}>
      {children}
    </p>
  );
};

type Props = {
  overViewData?: AdminOverviewStatus | null;
};

export const AccountInformation = ({ overViewData }: Props) => {
  return (
    <Card className={'flex flex-row gap-5 justify-between flex-wrap'}>
      {overViewData?.rithmic && (
        <div className={'flex flex-col gap-2'}>
          <Title>Rithmic</Title>
          <div className={'flex flex-col gap-1'}>
            <Desc bold>
              CSV File Upload:{' '}
              {overViewData.rithmic.pending_to_upload.public_files}/
              {overViewData.rithmic.pending_to_upload.private_files}
            </Desc>
            <Desc bold>
              Last Sync:{' '}
              {formatDateTimeMST(
                overViewData.rithmic.pending_to_upload.last_sync
              )}
            </Desc>
            <Desc bold>
              CSV File to Process:{' '}
              {overViewData.rithmic.file_processing.rithmic_paper_trading_count}
              /{overViewData.rithmic.file_processing.leeloo_trading_count}
            </Desc>
            <Desc bold>
              Last Check:{' '}
              {formatDateTimeMST(
                overViewData.rithmic.file_processing.last_check
              )}
            </Desc>
          </div>
        </div>
      )}
      {overViewData?.riseworks && (
        <div className={'flex flex-col gap-2'}>
          <Title>Riseworks</Title>
          <div className={'flex gap-x-8'}>
            <div className={'flex flex-col gap-y-1'}>
              <Desc bold>Invites:</Desc>
              <Desc bold>Onboarding:</Desc>
              <Desc bold>Complete:</Desc>
            </div>
            <div className={'flex flex-col gap-y-1'}>
              <Desc>{overViewData.riseworks.invites}</Desc>
              <Desc>{overViewData.riseworks.onboarding}</Desc>
              <Desc>{overViewData.riseworks.completed}</Desc>
            </div>
          </div>
          <Desc bold>
            Last Check: {formatDateTimeMST(overViewData.riseworks.last_sync)}
          </Desc>
        </div>
      )}
      {overViewData?.mint_stats && (
        <div className={'flex flex-col gap-2'}>
          <Title>MINT Stats</Title>
          <div className={'flex gap-x-6'}>
            <div className={'mt-[20px] flex flex-col gap-y-1'}>
              <Desc bold>Users:</Desc>
              <Desc bold>Complete:</Desc>
              <Desc bold>PA Accounts</Desc>
              <Desc bold>App Users</Desc>
            </div>
            <div className={'flex flex-col gap-y-1'}>
              <Desc>Active</Desc>
              <Desc>{overViewData.mint_stats.user_active}</Desc>
              <Desc>{overViewData.mint_stats.account_active}</Desc>
              <Desc>{overViewData.mint_stats.pa_account_active}</Desc>
              <Desc>{overViewData.mint_stats.app_user_active}</Desc>
            </div>
            <div className={'flex flex-col gap-y-1'}>
              <Desc>All Time</Desc>
              <Desc>{overViewData.mint_stats.user_all_time}</Desc>
              <Desc>{overViewData.mint_stats.account_all_time}</Desc>
              <Desc>{overViewData.mint_stats.pa_account_all_time}</Desc>
              <Desc>{overViewData.mint_stats.app_user_all_time}</Desc>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
};
